import * as types from './constants';

const initialState = {
  data: {},
  loading: false,
  errors_api: {}
};

const actions = {
  // Add Group Users
  [types.ADD_GROUP_USERS_REQUEST]: state => {
    const data = {
      ...state,
      addLoading: true
    };

    return { ...data };
  },

  [types.ADD_GROUP_USERS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      data: payload
    };

    return { ...data };
  },

  [types.ADD_GROUP_USERS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

